******手动广告*******
（广告组类型为关键词投放）
1、商品
2、关键词
3、用户搜索词
4、否定关键词
5、广告组高级设置

（广告组类型为商品投放）
1、商品
2、商品投放
3、否定商品投放
4、广告组高级设置

******自动广告*******

1、商品
2、投放组
3、用户搜索词
4、否定关键词
5、否定商品投放
6、广告组高级设置

<template>
  <el-tabs
      :value="activeTab || 'adProduct'"
      @tab-click="tabClick"
      class="ad-tabs">
    <el-tab-pane name="adProduct" lazy>
      <template #label>
        <span>广告</span>
        <gj-badge class="ad-badge" type="num" :value="cornerMarker.countAds || 0"></gj-badge>
      </template>
      <app-sp-ad-product
          :init-date="initDate"
          :market-id="marketId"
          :portfolio-id="portfolioId"
          :campaign-id="campaignId"
          :group-id="groupId"
          :campaign="proxyCampaign"
          :group="proxyGroup"
          table-name="spAdGroupProduct"
      ></app-sp-ad-product>
    </el-tab-pane>
    <el-tab-pane
        v-if="proxyCampaign.targetingType === AdCampaignEnum.SP.targetingType.AUTO"
        name="adTargetGroup" lazy>
      <template #label>
        <span>投放组</span>
        <gj-badge class="ad-badge" type="num" :value="cornerMarker.countTargetingGroups || 0"></gj-badge>
      </template>
      <app-sp-ad-target
          :init-date="initDate"
          :market-id="marketId"
          :portfolio-id="portfolioId"
          :campaign-id="campaignId"
          :group-id="groupId"
          :group="proxyGroup"
          table-name="spAdGroupTargetGroup"
      ></app-sp-ad-target>
    </el-tab-pane>
    <el-tab-pane
        v-if="proxyCampaign.targetingType === AdCampaignEnum.SP.targetingType.MANUAL
         && proxyGroup.groupTargetingType === AdGroupEnum.SP.targetingType.KEYWORD"
        name="adKeyword" lazy>
      <template #label>
        <span>关键词</span>
        <gj-badge class="ad-badge" type="num" :value="cornerMarker.countKeywords || 0"></gj-badge>
      </template>
      <app-sp-ad-keyword
          :init-date="initDate"
          :market-id="marketId"
          :portfolio-id="portfolioId"
          :campaign-id="campaignId"
          :group-id="groupId"
          :campaign="proxyCampaign"
          :group="proxyGroup"
          table-name="spAdGroupKeyword"
      ></app-sp-ad-keyword>
    </el-tab-pane>
    <el-tab-pane
        v-if="(proxyCampaign.targetingType === AdCampaignEnum.SP.targetingType.MANUAL && proxyGroup.groupTargetingType === AdGroupEnum.SP.targetingType.KEYWORD)
          || (proxyCampaign.targetingType === AdCampaignEnum.SP.targetingType.AUTO)"
        name="adNegKeyword" lazy>
      <template #label>
        <span>否定关键词</span>
        <gj-badge class="ad-badge" type="num" :value="cornerMarker.countNegativeKeywords || 0"></gj-badge>
      </template>
      <app-sp-ad-neg-keyword
          :init-date="initDate"
          manager-type="adGroupManager"
          :market-id="marketId"
          :portfolio-id="portfolioId"
          :campaign-id="campaignId"
          :group-id="groupId"
          :campaign="proxyCampaign"
          :group="proxyGroup"
          table-name="spAdGroupNegKeyword"
      ></app-sp-ad-neg-keyword>
    </el-tab-pane>
    <el-tab-pane
        v-if="AdCampaignEnum.SP.targetingType.MANUAL === proxyCampaign.targetingType
          && proxyGroup.groupTargetingType === AdGroupEnum.SP.targetingType.PRODUCT"
        name="adProductTarget" lazy>
      <template #label>
        <span>商品投放</span>
        <gj-badge class="ad-badge" type="num" :value="cornerMarker.countTargeting || 0"></gj-badge>
      </template>
      <app-sp-ad-product-target
          :init-date="initDate"
          :market-id="marketId"
          :portfolio-id="portfolioId"
          :campaign-id="campaignId"
          :group-id="groupId"
          :campaign="proxyCampaign"
          :group="proxyGroup"
          table-name="spAdCampaignProductTarget"
      ></app-sp-ad-product-target>
    </el-tab-pane>
    <el-tab-pane
        v-if="(proxyCampaign.targetingType === AdCampaignEnum.SP.targetingType.MANUAL && proxyGroup.groupTargetingType === AdGroupEnum.SP.targetingType.PRODUCT)
          || (proxyCampaign.targetingType === AdCampaignEnum.SP.targetingType.AUTO)"
        name="adNegTarget" lazy>
      <template #label>
        <span>否定商品投放</span>
        <gj-badge class="ad-badge" type="num" :value="cornerMarker.countNegativeTargeting || 0"></gj-badge>
      </template>
      <app-sp-ad-neg-target
          :init-date="initDate"
          :market-id="marketId"
          :portfolio-id="portfolioId"
          :campaign-id="campaignId"
          :group-id="groupId"
          :campaign="proxyCampaign"
          :group="proxyGroup"
          table-name="spAdGroupNegTarget"
      ></app-sp-ad-neg-target>
    </el-tab-pane>
    <el-tab-pane
        v-if="(proxyCampaign.targetingType === AdCampaignEnum.SP.targetingType.MANUAL && proxyGroup.groupTargetingType === AdGroupEnum.SP.targetingType.KEYWORD)
          || (proxyCampaign.targetingType === AdCampaignEnum.SP.targetingType.AUTO)"
        name="adSearchKeyword" lazy>
      <template #label>
        <span>用户搜索词</span>
      </template>
      <app-sp-ad-search-keyword
          :init-date="initDate"
          :market-id="marketId"
          :portfolio-id="portfolioId"
          :campaign-id="campaignId"
          :group-id="groupId"
          :campaign="proxyCampaign"
          :group="proxyGroup"
          table-name="spAdGroupSearchKeyword"
      ></app-sp-ad-search-keyword>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
  import AppSpAdProduct from "../components/ad-product/ad-product";
  import AppSpAdKeyword from "../components/ad-keyword/ad-keyword";
  import AppSpAdNegKeyword from "../components/ad-neg-keyword/ad-neg-keyword";
  import AppSpAdSearchKeyword from "../components/ad-search-word/ad-search-word";
  import { SP } from "../../../../../api/ad";
  import {AdCampaignEnum, AdGroupEnum} from "../../common/enum";
  import {adStore} from "../../common/store";
  import {
    inCampaignMixin,
    inGroupMixin,
    initDateMixin,
    inMarketMixin,
    inPortfolioMixin,
    tabResizeMixin
  } from "../../common/mixin";
  import AppSpAdNegTarget from "../components/ad-neg-target/ad-neg-target";
  import AppSpAdProductTarget from "../components/ad-product-target/ad-product-target";
  import {isMeaningful} from "../../../../../utils/common";
  import AppSpAdTarget from "../components/ad-target/ad-target";
  
  export default {
    name: "app-sp-ad-group-manager",
    components: {
      AppSpAdTarget,
      AppSpAdProductTarget,
      AppSpAdNegTarget, AppSpAdSearchKeyword,
      AppSpAdNegKeyword, AppSpAdKeyword, AppSpAdProduct},
    mixins: [inMarketMixin, inPortfolioMixin, inCampaignMixin, inGroupMixin, tabResizeMixin, initDateMixin],
    inject: ['cornerMarkerMap'],
    props: {
      activeTab: {
        default: 'adProduct',
      },
      groupTargetingType: {
        default: null
      }
    },
    created() {},
    data() {
      return {
        proxyCampaign: {},
        proxyGroup: {},
        AdCampaignEnum: AdCampaignEnum,
        AdGroupEnum: AdGroupEnum
      }
    },
    computed: {
      cornerMarker() {
        return this.cornerMarkerMap()
      }
    },
    methods: {
      campaignChange(campaignId) {
        SP.getCampaignDetails({
          marketId: this.marketId,
          campaignId
        })
          .then(({data}) => {
            if (isMeaningful(data)) {
              this.proxyCampaign = data;
            }
          })
          .complete(() => {});
      },
      groupChange(groupId) {
        SP.getGroupDetails({
          marketId: this.marketId,
          groupId
        })
          .then(({data}) => {
            if (isMeaningful(data)) {
              this.proxyGroup = data;
            }
          })
          .complete(() => {});
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../common/common.scss';
  .ad-badge{
    margin-left: 4px;
    /deep/ .el-badge__content{
      font-weight: 600;
      font-family: PingFangSC-Semibold;
    }
  }
  .ad-tabs{
    height: 100%;
    display: flex;
    flex-direction: column;
    /deep/ .el-tabs__content{
      flex: 1;
    }
    /deep/ .el-tab-pane{
      height: 100%;
    }
  }
</style>
